import Vue from 'vue'
import vuetify from './plugins/vuetify';
import VuetifyConfirm from 'vuetify-confirm'
import Croppa from 'vue-croppa';
import firebase from 'firebase'
import router from './router'
import { globalMixin } from './mixins/globalMixin.js'
import { store } from './store'
import './registerServiceWorker'
import App from './App.vue'

Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'Yes',
  buttonFalseText: 'No',
  color: 'warning',
  icon: 'mdi-alert',
  title: 'Please confirm',
  property: '$confirm'
});
Vue.use(Croppa);
Vue.mixin(globalMixin);
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  if (to.name == 'login') { //route is public, don't check for authentication
    next();
  } else {  //route is protected, if authenticated, proceed. Else, login
    let currentUser = firebase.auth().currentUser;
    if (currentUser && to.meta.protected) {
      //console.log("currentUser",JSON.stringify(currentUser))
      next();
    } else {
      router.push('/login');
    }
  }
})
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
